import React from 'react';

const Home = () => {
  return (
    <div className="home">
      <h1>Bienvenue</h1>
    </div>
  );
};

export default Home;